<div class="detail" [class.visible]="batch">
  <div class="close" (click)="close()"></div>
  <div class="batch-detail">
    <div *ngIf="!batch" class="loading">Loading . . .</div>
    <div *ngIf="batch">
      batch
    </div>
  </div>
</div>
